import * as yup from "yup";

import {
  IDepartmentPermission,
  IInviteTeamMember,
} from "../../../interfaces-and-types";

export interface IInviteTeamFormHelper {
  availableAccessClaimsSelectHelper?: string | null;
}

export const addTeamMemberValidationSchema: yup.SchemaOf<
  IInviteTeamMember & IInviteTeamFormHelper
> = yup
  .object({
    email: yup.string().email("Please enter a valid email address").required(),

    message: yup.string().max(300).nullable().optional(),

    user_access_claims: yup
      .array()
      .of(
        yup
          .string()
          .required("Please select an access role for the team member")
      )
      .min(1, "Please select at least one access claim for the team member"),

    auxillary_permissions: yup.array<IDepartmentPermission>().optional(),

    availableAccessClaimsSelectHelper: yup.string().nullable().optional(),
  })
  .required();
